import React from "react";
import { RouteComponentProps, withRouter } from "react-router";

import { LocationDescriptorObject } from "history";

interface ILinkTrProps extends RouteComponentProps<any>, React.HTMLAttributes<HTMLTableRowElement> {
    to: LocationDescriptorObject | string;
}

class LinkTr extends React.Component<ILinkTrProps> {
    constructor(props: ILinkTrProps) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleKey = this.handleKey.bind(this);
    }

    public render() {
        const { to, history, staticContext, match, location, ...props } = this.props;
        return <tr {...props} onClick={this.handleClick} onKeyDown={this.handleKey} tabIndex={0} />;
    }

    private handleClick(e: React.MouseEvent<HTMLTableRowElement>) {
        if (e.target instanceof HTMLAnchorElement) {
            return;
        }

        this.props.history.push(this.props.to as any);
    }

    private handleKey(e: React.KeyboardEvent<HTMLTableRowElement>) {
        if (e.key === "Enter" || e.key === " ") {
            this.props.history.push(this.props.to as any);
        }
    }
}

export default withRouter(LinkTr);
